import store from './store/index'

const can = (permission) => {
    return store.getters['auth/user'].permissions.findIndex(f => f.name.toLowerCase() === permission.toLowerCase()) !== -1;
}

export default can